var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash",class:{ visible: _vm.visible }},[_c('Spinner',{staticClass:"splash__logo"}),(_vm.label)?_c('h5',[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e(),_c('div',{staticClass:"splash__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }